// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "d8f8ac280325ec4df5a28c8b3dc5a5f6" + ".js";
};